// extracted by mini-css-extract-plugin
export default {"label":"SectionLabel_label__4LG1L"};